{
  "status": {
    "PLANNED": "مخطط",
    "READY": "جاهز",
    "INVOICED": "مفوتر",
    "CANCELLED": "ملغى"
  },
  "payment": {
    "UNPAID": "غير مدفوعة",
    "PARTIAL": "مدفوعة جزئيًا",
    "PAID": "مدفوعة",
    "OVERDUE": "متأخرة"
  },
  "errors": {
    "requestUsed": "فُوترت هذه الأقساط في محاولة سابقة. أغلق النافذة وراجع فواتير العقد.",
    "someItems": "لم يعد ممكنًا فوترة بعض الأقساط (فُوترت في الأثناء أو أُلغيت أو لم تحن بعد). أغلق النافذة واختر من جديد.",
    "changed": "غيّر شخص آخر هذا العقد في الأثناء. حُمّلت أحدث نسخة منه: راجعها وحاول مجددًا."
  },
  "salesOff": {
    "title": "المبيعات معطّلة لشركتك",
    "body": "تصبح الأقساط جاهزة في تاريخ فوترتها، لكن لا يمكن فوترتها حتى يُعاد تفعيل المبيعات."
  },
  "instalments": {
    "title": "الأقساط",
    "hint": "الجدول: {{schedule}} · {{timing}}",
    "scheduled": "المجدول (قبل الضريبة)",
    "select": "تحديد {{label}}",
    "selectAll": "تحديد كل قسط جاهز",
    "bills": "يُفوتر في {{date}}",
    "netAndTax": "{{net}} + ضريبة {{tax}}",
    "cancelledBecause": "أُلغي: {{reason}}",
    "frozen": "العقد بانتظار الاعتماد: لا تتغير أقساطه حتى يُبتّ فيه.",
    "empty": "لا أقساط بعد. أضف قسطًا أو أعد بناءها من الجدول.",
    "emptyCustom": "يُفوتر هذا العقد بجدول مخصص: أضف أقساطه يدويًا.",
    "emptyDraftNone": "عند تفعيل العقد تُنشأ أقساطه من الجدول.",
    "columns": {
      "select": "تحديد",
      "label": "القسط",
      "billingDate": "تاريخ الفوترة",
      "amount": "المبلغ",
      "tax": "الضريبة",
      "total": "الإجمالي",
      "status": "الحالة",
      "actions": "الإجراءات"
    },
    "emptyDraft_zero": "عند تفعيل العقد تُنشأ أقساطه من الجدول ({{schedule}}).",
    "emptyDraft_one": "عند تفعيل العقد يُنشأ له قسط واحد من الجدول ({{schedule}}).",
    "emptyDraft_two": "عند تفعيل العقد يُنشأ له قسطان من الجدول ({{schedule}}).",
    "emptyDraft_few": "عند تفعيل العقد يُنشأ له {{n}} أقساط من الجدول ({{schedule}}).",
    "emptyDraft_many": "عند تفعيل العقد يُنشأ له {{n}} قسطًا من الجدول ({{schedule}}).",
    "emptyDraft_other": "عند تفعيل العقد يُنشأ له {{n}} قسط من الجدول ({{schedule}}).",
    "bulk_zero": "لا أقساط محدد · {{total}}",
    "bulk_one": "قسط واحد محدد · {{total}}",
    "bulk_two": "قسطان محدد · {{total}}",
    "bulk_few": "{{n}} أقساط محدد · {{total}}",
    "bulk_many": "{{n}} قسطًا محدد · {{total}}",
    "bulk_other": "{{n}} قسط محدد · {{total}}"
  },
  "actions": {
    "add": "إضافة قسط",
    "edit": "تعديل",
    "cancel": "إلغاء القسط",
    "label": "إجراءات {{label}}",
    "invoice": "فوترة",
    "invoiceNamed": "فوترة {{label}}",
    "rebuild": "إعادة البناء من الجدول",
    "invoiceMany_zero": "فوترة لا أقساط",
    "invoiceMany_one": "فوترة قسط واحد",
    "invoiceMany_two": "فوترة قسطان",
    "invoiceMany_few": "فوترة {{n}} أقساط",
    "invoiceMany_many": "فوترة {{n}} قسطًا",
    "invoiceMany_other": "فوترة {{n}} قسط"
  },
  "drawer": {
    "newTitle": "إضافة قسط",
    "editTitle": "تعديل {{label}}",
    "changed": "عدّل شخص آخر هذا القسط منذ أن فتحته. لم تُحفظ تعديلاتك؛ حمّل الأحدث لترى تعديله، ثم أعد تعديلاتك.",
    "loadLatest": "تحميل الأحدث",
    "description": "قسط من {{number}}: يصبح جاهزًا للفوترة في تاريخ فوترته.",
    "label": "التسمية",
    "labelHint": "تُطبع على سطر الفاتورة مع رقم العقد والفترة.",
    "labelPlaceholder": "الربع الأول 2027، يناير 2027",
    "periodStart": "الفترة من",
    "periodEnd": "الفترة إلى",
    "billingDate": "تاريخ الفوترة",
    "billingDateHint": "جاهز للفوترة من هذا اليوم.",
    "amount": "المبلغ قبل الضريبة",
    "amountHint": "بالريال العماني، ثلاث منازل عشرية.",
    "amountRest": "ينقص الجدولَ {{amount}} من قيمة العقد.",
    "tax": "نسبة الضريبة",
    "contractRate": "نسبة العقد",
    "contractRateNamed": "نسبة العقد: {{rate}}",
    "add": "إضافة القسط",
    "save": "حفظ القسط",
    "errors": {
      "label": "اكتب تسمية للقسط",
      "amount": "أدخل مبلغًا أكبر من صفر",
      "period": "اختر تاريخًا ضمن مدة العقد",
      "periodEnd": "تنتهي الفترة قبل أن تبدأ",
      "billingDate": "اختر تاريخ الفوترة",
      "field": "راجع هذا الحقل"
    }
  },
  "cancel": {
    "title": "إلغاء {{label}}؟",
    "body": "يبقى ظاهرًا مشطوبًا ويخرج من الجدول ({{amount}} قبل الضريبة)، ولا يمكن فوترته بعد ذلك.",
    "reason": "السبب",
    "reasonRequired": "اذكر السبب",
    "confirm": "إلغاء القسط"
  },
  "rebuild": {
    "title": "إعادة بناء الأقساط من الجدول؟",
    "none": "تُنشأ الأقساط من الجدول ({{schedule}}) لما لم يُفوتر بعد.",
    "unchanged": "لن يتغير شيء: الأقساط غير المفوترة تتبع الجدول أصلاً.",
    "makesNone": "لن يُنشأ أي قسط: الأقساط المفوترة تغطي القيمة.",
    "makes_zero": "لا يُنشئ أي قسط:",
    "makes_one": "يُنشئ قسطاً واحداً:",
    "makes_two": "يُنشئ قسطين:",
    "makes_few": "يُنشئ {{n}} أقساط:",
    "makes_many": "يُنشئ {{n}} قسطاً:",
    "makes_other": "يُنشئ {{n}} قسط:",
    "kept": "تبقى الأقساط المفوترة كما هي.",
    "confirm": "إعادة البناء",
    "body_zero": "تُستبدل الأقساط غير المفوترة (لا أقساط، {{amount}} قبل الضريبة) بأقساط من الجدول ({{schedule}}) لما لم يُفوتر.",
    "body_one": "تُستبدل الأقساط غير المفوترة (قسط واحد، {{amount}} قبل الضريبة) بأقساط من الجدول ({{schedule}}) لما لم يُفوتر.",
    "body_two": "تُستبدل الأقساط غير المفوترة (قسطان، {{amount}} قبل الضريبة) بأقساط من الجدول ({{schedule}}) لما لم يُفوتر.",
    "body_few": "تُستبدل الأقساط غير المفوترة ({{n}} أقساط، {{amount}} قبل الضريبة) بأقساط من الجدول ({{schedule}}) لما لم يُفوتر.",
    "body_many": "تُستبدل الأقساط غير المفوترة ({{n}} قسطًا، {{amount}} قبل الضريبة) بأقساط من الجدول ({{schedule}}) لما لم يُفوتر.",
    "body_other": "تُستبدل الأقساط غير المفوترة ({{n}} قسط، {{amount}} قبل الضريبة) بأقساط من الجدول ({{schedule}}) لما لم يُفوتر."
  },
  "toast": {
    "added": "أُضيف القسط {{label}}",
    "saved": "حُفظ القسط {{label}}",
    "cancelled": "أُلغي القسط {{label}}",
    "rebuilt_zero": "أُعيد بناء الأقساط: لا أقساط في الجدول",
    "rebuilt_one": "أُعيد بناء الأقساط: قسط واحد في الجدول",
    "rebuilt_two": "أُعيد بناء الأقساط: قسطان في الجدول",
    "rebuilt_few": "أُعيد بناء الأقساط: {{n}} أقساط في الجدول",
    "rebuilt_many": "أُعيد بناء الأقساط: {{n}} قسطًا في الجدول",
    "rebuilt_other": "أُعيد بناء الأقساط: {{n}} قسط في الجدول"
  },
  "invoices": {
    "title": "الفواتير",
    "hint": "فواتير المبيعات لأقساط العقد، الأحدث أولًا. تُحصّل الدفعات في المبيعات.",
    "empty": "لا فواتير لـ {{number}} بعد.",
    "draft": "مسودة",
    "balance": "الرصيد",
    "columns": {
      "number": "الفاتورة",
      "date": "التاريخ",
      "status": "الحالة",
      "total": "الإجمالي",
      "paid": "المدفوع",
      "balance": "الرصيد"
    }
  },
  "sheet": {
    "description": "فاتورة مبيعات مرحّلة لكل عقد، بسطر لكل قسط. راجعها قبل الترحيل.",
    "invoiceDate": "تاريخ الفاتورة",
    "invoiceDateHint": "يتبع تاريخ الاستحقاق شروط الدفع للعميل.",
    "notes": "ملاحظات",
    "notesHint": "اختيارية. تُطبع على كل فاتورة.",
    "previewFailed": "تعذّر تجهيز الفواتير",
    "nothing": "لا يمكن فوترة أي من هذه الأقساط الآن.",
    "billTo": "الفاتورة إلى",
    "reference": "المرجع",
    "previewStamp": "معاينة",
    "slip": "فاتورة {{number}}",
    "lines": "أسطر فاتورة {{number}}",
    "columns": {
      "description": "البيان",
      "net": "المبلغ"
    },
    "taxLine": "{{rate}} · ضريبة {{tax}}",
    "noTax": "بلا ضريبة",
    "subtotal": "المجموع الفرعي",
    "tax": "الضريبة",
    "total": "الإجمالي",
    "posts": "الترحيل نهائي: يُصحَّح الخطأ بإلغاء الفاتورة في المبيعات.",
    "retry": "حاول مجددًا",
    "failed": "لم تُرحّل الفواتير",
    "salesOffTitle": "المبيعات معطّلة لشركتك",
    "salesOffBody": "لا يمكن فوترة الأقساط حتى يُعاد تفعيل المبيعات.",
    "repeatBody": "رُحّلت هذه الفواتير في محاولة سابقة لهذا الطلب؛ لم يُرحَّل شيء مرتين.",
    "forContract": "العقد {{number}}",
    "done": "تم",
    "title_zero": "فوترة لا أقساط",
    "title_one": "فوترة قسط واحد",
    "title_two": "فوترة قسطان",
    "title_few": "فوترة {{n}} أقساط",
    "title_many": "فوترة {{n}} قسطًا",
    "title_other": "فوترة {{n}} قسط",
    "consequence_zero": "سيُرحَّل لا فواتير عن {{items}}، بإجمالي {{total}} شامل الضريبة.",
    "consequence_one": "سيُرحَّل فاتورة واحدة عن {{items}}، بإجمالي {{total}} شامل الضريبة.",
    "consequence_two": "سيُرحَّل فاتورتان عن {{items}}، بإجمالي {{total}} شامل الضريبة.",
    "consequence_few": "سيُرحَّل {{n}} فواتير عن {{items}}، بإجمالي {{total}} شامل الضريبة.",
    "consequence_many": "سيُرحَّل {{n}} فاتورة عن {{items}}، بإجمالي {{total}} شامل الضريبة.",
    "consequence_other": "سيُرحَّل {{n}} فاتورة عن {{items}}، بإجمالي {{total}} شامل الضريبة.",
    "refusedTitle_zero": "سيُستثنى لا أقساط",
    "refusedTitle_one": "سيُستثنى قسط واحد",
    "refusedTitle_two": "سيُستثنى قسطان",
    "refusedTitle_few": "سيُستثنى {{n}} أقساط",
    "refusedTitle_many": "سيُستثنى {{n}} قسطًا",
    "refusedTitle_other": "سيُستثنى {{n}} قسط",
    "confirm_zero": "ترحيل لا فواتير",
    "confirm_one": "ترحيل فاتورة واحدة",
    "confirm_two": "ترحيل فاتورتان",
    "confirm_few": "ترحيل {{n}} فواتير",
    "confirm_many": "ترحيل {{n}} فاتورة",
    "confirm_other": "ترحيل {{n}} فاتورة",
    "toast_zero": "رُحّلت لا فواتير",
    "toast_one": "رُحّلت فاتورة واحدة",
    "toast_two": "رُحّلت فاتورتان",
    "toast_few": "رُحّلت {{n}} فواتير",
    "toast_many": "رُحّلت {{n}} فاتورة",
    "toast_other": "رُحّلت {{n}} فاتورة",
    "toastRepeat_zero": "مرحّلة سابقًا: لا فواتير",
    "toastRepeat_one": "مرحّلة سابقًا: فاتورة واحدة",
    "toastRepeat_two": "مرحّلة سابقًا: فاتورتان",
    "toastRepeat_few": "مرحّلة سابقًا: {{n}} فواتير",
    "toastRepeat_many": "مرحّلة سابقًا: {{n}} فاتورة",
    "toastRepeat_other": "مرحّلة سابقًا: {{n}} فاتورة",
    "doneTitle_zero": "رُحّلت لا فواتير",
    "doneTitle_one": "رُحّلت فاتورة واحدة",
    "doneTitle_two": "رُحّلت فاتورتان",
    "doneTitle_few": "رُحّلت {{n}} فواتير",
    "doneTitle_many": "رُحّلت {{n}} فاتورة",
    "doneTitle_other": "رُحّلت {{n}} فاتورة",
    "doneBody_zero": "رُحّلت لا فواتير في المبيعات، بإجمالي {{total}} شامل الضريبة.",
    "doneBody_one": "رُحّلت فاتورة واحدة في المبيعات، بإجمالي {{total}} شامل الضريبة.",
    "doneBody_two": "رُحّلت فاتورتان في المبيعات، بإجمالي {{total}} شامل الضريبة.",
    "doneBody_few": "رُحّلت {{n}} فواتير في المبيعات، بإجمالي {{total}} شامل الضريبة.",
    "doneBody_many": "رُحّلت {{n}} فاتورة في المبيعات، بإجمالي {{total}} شامل الضريبة.",
    "doneBody_other": "رُحّلت {{n}} فاتورة في المبيعات، بإجمالي {{total}} شامل الضريبة.",
    "instalments_zero": "لا أقساط",
    "instalments_one": "قسط واحد",
    "instalments_two": "قسطين",
    "instalments_few": "{{n}} أقساط",
    "instalments_many": "{{n}} قسطًا",
    "instalments_other": "{{n}} قسط"
  },
  "preview": {
    "refused": {
      "invoiced": "مفوتر سابقًا",
      "cancelled": "ملغى",
      "notFound": "لم يعد موجودًا",
      "notActive": "لا يمكن فوترة عقده الآن",
      "notReady": "لم يحن موعد فوترته"
    }
  },
  "queue": {
    "title": "فوترة العقود",
    "intro": "الأقساط التي حلّ تاريخ فوترتها في كل العقود. حدّدها ورحّل فواتيرها: فاتورة لكل عقد.",
    "tableLabel": "الأقساط الجاهزة للفوترة",
    "searchPlaceholder": "ابحث برقم العقد أو العميل أو القسط…",
    "searchLabel": "البحث في الأقساط الجاهزة",
    "clearSearch": "مسح البحث",
    "clearFilters": "مسح عوامل التصفية",
    "filterCustomer": "العميل",
    "anyCustomer": "أي عميل",
    "contractFilter": "العقد",
    "clearContract": "عرض كل العقود",
    "select": "تحديد {{label}} من {{number}}",
    "selectAll": "تحديد كل الأقساط في هذه الصفحة",
    "columns": {
      "contract": "العقد",
      "instalment": "القسط",
      "billingDate": "تاريخ الفوترة",
      "amount": "المبلغ",
      "tax": "الضريبة",
      "total": "الإجمالي"
    },
    "empty": {
      "title": "لا شيء للفوترة",
      "body": "تظهر الأقساط هنا في تاريخ فوترتها.",
      "filteredTitle": "لا قسط جاهز يطابق البحث",
      "filteredBody": "غيّر البحث أو امسح عوامل التصفية."
    },
    "summary_zero": "لا أقساط جاهز للفوترة",
    "summary_one": "قسط واحد جاهز للفوترة",
    "summary_two": "قسطان جاهز للفوترة",
    "summary_few": "{{n}} أقساط جاهز للفوترة",
    "summary_many": "{{n}} قسطًا جاهز للفوترة",
    "summary_other": "{{n}} قسط جاهز للفوترة",
    "invoice_zero": "فوترة لا أقساط · {{total}}",
    "invoice_one": "فوترة قسط واحد · {{total}}",
    "invoice_two": "فوترة قسطان · {{total}}",
    "invoice_few": "فوترة {{n}} أقساط · {{total}}",
    "invoice_many": "فوترة {{n}} قسطًا · {{total}}",
    "invoice_other": "فوترة {{n}} قسط · {{total}}"
  },
  "insights": {
    "title": "مؤشرات العقود",
    "intro": "كيف تُنفَّذ عقود الصيانة: ما يحتاج إلى عمل الآن، والزيارات الوقائية المنجزة مقابل المستحقة، والمعدات كثيرة الأعطال، والضمان، والتجديدات، ولمن يرى المبالغ ما يربحه كل عقد.",
    "attention": {
      "title": "يحتاج إلى انتباه",
      "empty": "لا شيء يحتاج إلى انتباه.",
      "renew": "تجديد",
      "renewNamed": "تجديد {{number}}",
      "kind": {
        "VISIT_OVERDUE": "زيارة وقائية متأخرة",
        "RENEWAL_DUE": "تجديد مستحق",
        "BILLING_READY": "جاهز للفوترة",
        "WARRANTY_EXPIRING": "ضمان ينتهي",
        "PROBLEM_ASSET": "معدة كثيرة الأعطال"
      },
      "label": {
        "PROBLEM_ASSET": "{{tag}} في {{site}} تتكرر أعطالها",
        "VISIT_OVERDUE_zero": "{{job}} في {{site}}: زيارة وقائية متأخرة أقل من يوم",
        "VISIT_OVERDUE_one": "{{job}} في {{site}}: زيارة وقائية متأخرة يوم واحد",
        "VISIT_OVERDUE_two": "{{job}} في {{site}}: زيارة وقائية متأخرة يومين",
        "VISIT_OVERDUE_few": "{{job}} في {{site}}: زيارة وقائية متأخرة {{n}} أيام",
        "VISIT_OVERDUE_many": "{{job}} في {{site}}: زيارة وقائية متأخرة {{n}} يومًا",
        "VISIT_OVERDUE_other": "{{job}} في {{site}}: زيارة وقائية متأخرة {{n}} يوم",
        "RENEWAL_DUE_zero": "{{number}} · {{customer}} ينتهي خلال أقل من يوم ولم يُجدَّد",
        "RENEWAL_DUE_one": "{{number}} · {{customer}} ينتهي خلال يوم واحد ولم يُجدَّد",
        "RENEWAL_DUE_two": "{{number}} · {{customer}} ينتهي خلال يومين ولم يُجدَّد",
        "RENEWAL_DUE_few": "{{number}} · {{customer}} ينتهي خلال {{n}} أيام ولم يُجدَّد",
        "RENEWAL_DUE_many": "{{number}} · {{customer}} ينتهي خلال {{n}} يومًا ولم يُجدَّد",
        "RENEWAL_DUE_other": "{{number}} · {{customer}} ينتهي خلال {{n}} يوم ولم يُجدَّد",
        "BILLING_READY_zero": "{{number}} · {{customer}}: لا أقساط جاهز للفوترة، {{total}}",
        "BILLING_READY_one": "{{number}} · {{customer}}: قسط واحد جاهز للفوترة، {{total}}",
        "BILLING_READY_two": "{{number}} · {{customer}}: قسطان جاهز للفوترة، {{total}}",
        "BILLING_READY_few": "{{number}} · {{customer}}: {{n}} أقساط جاهز للفوترة، {{total}}",
        "BILLING_READY_many": "{{number}} · {{customer}}: {{n}} قسطًا جاهز للفوترة، {{total}}",
        "BILLING_READY_other": "{{number}} · {{customer}}: {{n}} قسط جاهز للفوترة، {{total}}",
        "WARRANTY_EXPIRING_zero": "ضمان {{tag}} في {{site}} ينتهي خلال أقل من يوم",
        "WARRANTY_EXPIRING_one": "ضمان {{tag}} في {{site}} ينتهي خلال يوم واحد",
        "WARRANTY_EXPIRING_two": "ضمان {{tag}} في {{site}} ينتهي خلال يومين",
        "WARRANTY_EXPIRING_few": "ضمان {{tag}} في {{site}} ينتهي خلال {{n}} أيام",
        "WARRANTY_EXPIRING_many": "ضمان {{tag}} في {{site}} ينتهي خلال {{n}} يومًا",
        "WARRANTY_EXPIRING_other": "ضمان {{tag}} في {{site}} ينتهي خلال {{n}} يوم"
      },
      "reason": {
        "VISIT_OVERDUE": "{{plan}} · {{number}} · مستحقة في {{date}}",
        "RENEWAL_DUE": "ينتهي في {{date}}",
        "BILLING_READY": "جاهز منذ {{date}}",
        "WARRANTY_EXPIRING": "حتى {{date}} · يشملها {{number}}",
        "WARRANTY_EXPIRING_BARE": "حتى {{date}}",
        "PROBLEM_ASSET": "{{issues}} و{{faults}} خلال 90 يومًا · آخرها {{date}}"
      }
    },
    "compliance": {
      "title": "الالتزام حسب العقد",
      "hint": "العقود النشطة، الأسوأ أولًا: الزيارات الوقائية المنجزة من المستحقة، دون المتخطاة.",
      "last12": "آخر 12 فترة",
      "stripLabel": "{{number}}: آخر الفترات",
      "noPlans": "لا زيارات وقائية",
      "counts": "{{done}} من {{due}} منجزة · {{skipped}} متخطاة",
      "empty": "لا يوجد عقد نشط له زيارات وقائية بعد."
    },
    "renewals": {
      "title": "التجديدات",
      "hint": "العقود النشطة التي تنتهي خلال 90 يومًا.",
      "endsToday": "ينتهي اليوم",
      "notRenewed": "لم يُجدَّد",
      "empty": "لا عقد ينتهي خلال 90 يومًا.",
      "endsIn_zero": "ينتهي خلال أقل من يوم",
      "endsIn_one": "ينتهي خلال يوم واحد",
      "endsIn_two": "ينتهي خلال يومين",
      "endsIn_few": "ينتهي خلال {{n}} أيام",
      "endsIn_many": "ينتهي خلال {{n}} يومًا",
      "endsIn_other": "ينتهي خلال {{n}} يوم"
    },
    "warranty": {
      "title": "ضمان ينتهي",
      "hint": "المعدات المشمولة التي ينتهي ضمانها خلال 60 يومًا.",
      "endsToday": "ينتهي اليوم",
      "empty": "لا ضمان ينتهي خلال 60 يومًا.",
      "daysLeft_zero": "أقل من يوم",
      "daysLeft_one": "بقي يوم واحد",
      "daysLeft_two": "بقي يومان",
      "daysLeft_few": "بقيت {{n}} أيام",
      "daysLeft_many": "بقي {{n}} يومًا",
      "daysLeft_other": "بقي {{n}} يوم"
    },
    "problems": {
      "title": "معدات كثيرة الأعطال",
      "hint": "أكثر المشكلات المسجلة في الفحوص وأوامر الأعطال خلال آخر 90 يومًا.",
      "empty": "لم تُسجَّل مشكلات أو أوامر أعطال لأي معدة خلال آخر 90 يومًا."
    },
    "profit": {
      "title": "الربحية",
      "invoiced": "المفوتر",
      "parts": "القطع المشمولة",
      "margin": "الهامش",
      "marginPercent": "نسبة الهامش",
      "estimated": "تقديري: تُقيَّم القطع المشمولة بمتوسط تكلفتها. المفوتر هو فواتير الأقساط مع الفواتير القابلة للتحصيل لأوامر العقد، قبل الضريبة.",
      "empty": "لم يُفوتر شيء على أي عقد بعد."
    },
    "columns": {
      "contract": "العقد",
      "compliance": "الالتزام",
      "visits": "الزيارات",
      "endsIn": "ينتهي",
      "value": "القيمة",
      "renewal": "التجديد",
      "asset": "المعدة",
      "site": "الموقع",
      "issues": "المشكلات",
      "faultJobs": "أوامر الأعطال",
      "last": "الأخير"
    },
    "issues_zero": "لا مشكلات",
    "issues_one": "مشكلة واحدة",
    "issues_two": "مشكلتان",
    "issues_few": "{{n}} مشكلات",
    "issues_many": "{{n}} مشكلة",
    "issues_other": "{{n}} مشكلة",
    "faultJobs_zero": "لا أوامر أعطال",
    "faultJobs_one": "أمر عطل واحد",
    "faultJobs_two": "أمرا عطل",
    "faultJobs_few": "{{n}} أوامر أعطال",
    "faultJobs_many": "{{n}} أمر عطل",
    "faultJobs_other": "{{n}} أمر عطل"
  },
  "strip": {
    "scheduledOf": "المجدول {{scheduled}} من {{value}}، قبل الضريبة",
    "differenceOverBy": "تزيد الأقساط على قيمة العقد بمبلغ {{amount}}.",
    "differenceShortBy": "تنقص الأقساط عن قيمة العقد بمبلغ {{amount}}."
  }
}
